import React from 'react';
import Svg, { Path, G, Defs, ClipPath } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const Vaccinations: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 60)} fill="none">
            <G clipPath="url(#clip0_1692_14155)" stroke={props.color}>
                <Path
                    d="M8.463 53.487L40.5 21.451a1.632 1.632 0 00-2.308-2.308L6.156 51.18a1.632 1.632 0 002.307 2.307z"
                    fill="#fff"
                    strokeMiterlimit={10}
                />
                <Path
                    d="M51.766 12.58l-4.702-4.702-30.857 30.857 4.702 4.702L51.766 12.58z"
                    fill="#fff"
                    strokeMiterlimit={10}
                />
                <Path
                    d="M48.22 18.343l-6.92-6.92L18.053 34.67l6.92 6.92 23.246-23.247z"
                    fill="#fff"
                    strokeMiterlimit={10}
                />
                <Path
                    d="M49.462 18.243L41.4 10.18a1.615 1.615 0 00-2.284 2.284l8.062 8.062a1.615 1.615 0 102.284-2.284zM53.848 11.745l-5.95-5.95a1.615 1.615 0 10-2.285 2.284l5.951 5.95a1.615 1.615 0 002.284-2.284zM33.877 32.686l-6.92-6.92-8.904 8.904 6.92 6.92 8.904-8.904z"
                    fill="#fff"
                    strokeMiterlimit={10}
                />
                <Path
                    transform="rotate(45 34.992 18.295)"
                    fill="#fff"
                    strokeWidth={0.785733}
                    d="M34.9917 18.2947H39.77753V19.080433H34.9917z"
                />
                <Path
                    transform="rotate(45 30.547 22.74)"
                    fill="#fff"
                    strokeWidth={0.785733}
                    d="M30.5471 22.7396H35.33293V23.525333H30.5471z"
                />
                <Path
                    transform="rotate(45 26.102 27.184)"
                    fill="#fff"
                    strokeWidth={0.785733}
                    d="M26.1025 27.1844H30.88833V27.970133H26.1025z"
                />
                <Path
                    d="M17.7 35.023l.756.756-2.602 2.602-.354.354.354.353.844.844L5.803 50.827a2.132 2.132 0 003.014 3.014l10.895-10.895.844.845.354.353.353-.353 2.602-2.602.755.754.353.354.354-.354 21.28-21.28.218.218a2.115 2.115 0 102.99-2.992l-1.325-1.325 2.451-2.45.27.27a2.115 2.115 0 102.991-2.992l-5.95-5.95a2.115 2.115 0 10-2.992 2.99l.272.272-2.451 2.45-1.327-1.327a2.115 2.115 0 10-2.991 2.991l.217.218-21.28 21.28-.354.354.354.353z"
                    strokeMiterlimit={10}
                />
            </G>
            <Defs>
                <ClipPath id="clip0_1692_14155">
                    <Path fill="#fff" d="M0 0H60V60H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    );
};

export default React.memo(Vaccinations);
